import { render } from "./EmailLists.vue?vue&type=template&id=6c68a8bf&scoped=true"
import script from "./EmailLists.vue?vue&type=script&lang=js"
export * from "./EmailLists.vue?vue&type=script&lang=js"

import "./EmailLists.vue?vue&type=style&index=0&id=6c68a8bf&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c68a8bf"]])

export default __exports__